import React, {Component, Fragment} from 'react';
import {observer} from 'mobx-react';

import Page from 'lib/struct/page/Page';
import Field from 'lib/struct/form/fields/Field';
import Select from 'lib/struct/form/Select';
import SpanButton, {Colors} from 'lib/struct/button/SpanButton';

import GroupScopeSettingsForm from './GroupScopeSettingsForm';
import * as MarkupTemplateId from 'settings/constant/MarkupTemplateId';
import * as GroupSettingsScope from 'domain/constant/GroupSettingsScope';

import styles from './GroupSettings.less';

@observer export default class GroupSettings extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;
		const group = context.edited_group;

		if (!group) {
			return <div/>;
		}

		return (
			<Page
				header={<h2>Настройки группы{group.name ? (` "${group.name}"`) : ('')} </h2>}
				footer={<GroupSettingsControls context={context} />}
			>
				{
					group.markup_template_id === MarkupTemplateId.COLOR_GROUP ? (
						<Fragment>
							<Field label='Характеристика цвета'>
								<Select
									options={context.color_feature_options}
									value={group.related_feature_id}
									onChange={e => group.related_feature_id = e.target.value}
								/>
							</Field>
						</Fragment>
					) : (null)
				}

				{
					GroupSettingsScope.scopes.map(scope => (
						<GroupScopeSettingsForm
							key={scope}
							context={context}
							header={GroupSettingsScope.label[scope]}
							scope={scope}
						/>
					))
				}
			</Page>
		);
	}
}

class GroupSettingsControls extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;
		const group = context.edited_group;

		if (!group) {
			return <div/>;
		}

		return (
			<div className={styles['group__control-block']}>
				<SpanButton
					color={Colors.GREEN}
					onClick={() => context.closeGroupSettingsPopup()}
				>
					Применить
				</SpanButton>
			</div>
		);
	}
}